import { Button, CircularProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import theme from "src/themes";

const Wishlist = ({
  rowData,
  handleClick
}: {
  rowData: any;
  handleClick: any;
}) => {
  const { t } = useTranslation();
  const wishlistStatus = rowData?.wishlist;
  const [loading, setLoading] = useState(false);

  const onClick = useCallback(() => {
    setLoading(true);
    handleClick(rowData);
  }, [handleClick, rowData]);

  useEffect(() => {
    setLoading(false);
  }, [rowData]);

  return (
    <Stack direction={"row"}>
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          margin: "8px",
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.main
        }}
      >
        {wishlistStatus
          ? t("realtimeSalesReport.removeFromWishlist")
          : t("realtimeSalesReport.addToWishlist")}
      </Button>
      {loading && (
        <Stack sx={{ paddingTop: 1.7 }}>
          <CircularProgress
            size="21px"
            sx={{
              color: "grey.600"
            }}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default Wishlist;
